import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { getBoletines } from "../repository";

/**
 * Popup "Nuevos Desarrollos": lista los boletines PDF mensuales
 * (contenedor de Azure Blob leído por el backend). El más reciente se destaca.
 */
const NuevosDesarrollosModal = ({ isOpen, onClose }) => {
  const [boletines, setBoletines] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    setCargando(true);
    setError(false);
    getBoletines().then((response) => {
      if (response && response.status === "success") {
        setBoletines(response.result || []);
      } else {
        setError(true);
      }
      setCargando(false);
    });

    // Cerrar con Escape y bloquear scroll del fondo
    const handleKeyDown = (e) => {
      if (e.key === "Escape" || e.keyCode === 27) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    const overflowPrevio = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = overflowPrevio;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const registraEvento = (boletin) => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "ver_nuevos_desarrollos", { boletin: boletin.archivo });
    }
  };

  const [actual, ...anteriores] = boletines;

  return createPortal(
    <div className="nd-overlay" onClick={onClose}>
      <div
        className="nd-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="nd-titulo"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="nd-close" onClick={onClose} aria-label="Cerrar">
          <i className="fa-solid fa-xmark"></i>
        </button>

        <h2 id="nd-titulo" className="nd-title">
          Nuevos Desarrollos
        </h2>
        <p className="nd-subtitle">
          Consulta los boletines mensuales con los nuevos productos GROB.
        </p>

        {cargando && (
          <div className="nd-status">
            <i className="fa-solid fa-spinner fa-spin"></i> Cargando boletines...
          </div>
        )}

        {!cargando && error && (
          <div className="nd-status">
            No fue posible cargar los boletines. Intenta de nuevo más tarde.
          </div>
        )}

        {!cargando && !error && !actual && (
          <div className="nd-status">Aún no hay boletines publicados.</div>
        )}

        {!cargando && !error && actual && (
          <>
            <a
              href={actual.url}
              target="_blank"
              rel="noopener noreferrer"
              className="nd-actual"
              onClick={() => registraEvento(actual)}
            >
              <i className="fa-solid fa-file-pdf nd-actual-icon"></i>
              <span className="nd-actual-text">
                <span className="nd-actual-label">Edición más reciente</span>
                <span className="nd-actual-titulo">{actual.titulo}</span>
              </span>
              <span className="nd-actual-btn">
                Ver boletín <i className="fa-solid fa-arrow-up-right-from-square"></i>
              </span>
            </a>

            {anteriores.length > 0 && (
              <>
                <h3 className="nd-historico-title">Ediciones anteriores</h3>
                <ul className="nd-historico">
                  {anteriores.map((boletin) => (
                    <li key={boletin.archivo}>
                      <a
                        href={boletin.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nd-historico-item"
                        onClick={() => registraEvento(boletin)}
                      >
                        <i className="fa-solid fa-file-pdf"></i>
                        <span>{boletin.titulo}</span>
                        <i className="fa-solid fa-arrow-up-right-from-square nd-historico-ext"></i>
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </>
        )}
      </div>
    </div>,
    document.body
  );
};

export default NuevosDesarrollosModal;
